import { Link } from "@tanstack/react-router";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL, BUSINESS, CONTACT_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function RoomsCTA() {
  const photo = PHOTOS.sign;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-28 sm:py-32 lg:py-40"
      aria-labelledby="rooms-cta-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(180deg,oklch(0.259_0.042_163.6/0.84)_0%,oklch(0.259_0.042_163.6/0.93)_100%)]"
        aria-hidden="true"
      />

      <Reveal className="mx-auto max-w-3xl px-4 text-center text-cream sm:px-6">
        <p className="eyebrow text-sand">Your Destination Starts Here</p>
        <h2
          id="rooms-cta-title"
          className="mt-4 text-balance font-display text-3xl leading-tight sm:text-4xl lg:text-[3rem]"
        >
          Find Your Place at Amigo Inn
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg">
          Choose your dates and explore the available RV sites, cabins, rooms, and camping options
          for your visit to Zapata, Texas.
        </p>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-cream/65">
          Rates, minimum-stay requirements, unit features, and availability may change. Use the
          online reservation system to review the latest information for your selected dates.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Button asChild variant="book" size="ctaLg">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Check Availability <ArrowRight aria-hidden="true" />
            </a>
          </Button>
          <Button asChild variant="outlineLight" size="ctaLg">
            <Link to={routeTo(CONTACT_PATH)}>Contact Us</Link>
          </Button>
        </div>
        <a
          href={BUSINESS.phoneHref}
          className="link-underline mt-8 inline-flex text-sm font-semibold text-sand"
        >
          <Phone className="size-4" aria-hidden="true" /> Call {BUSINESS.phone}
        </a>
      </Reveal>
    </section>
  );
}
